import React, { useState } from "react";
import cx from "classnames";
import { createStyles, makeStyles } from "@mui/styles";
import { alpha } from "@mui/material/styles";
import List from "components/common/List";
import Divider from "components/common/Divider";
import ListItem from "components/common/ListItem";
import IconButton from "components/common/IconButton";
import ListItemText from "components/common/ListItemText";
import ListItemIcon from "components/common/ListItemIcon";
import ListItemAvatar from "components/common/ListItemAvatar";
import ListSubheader from "components/common/ListSubheader";
import ListItemButton from "components/common/ListItemButton";
import ListItemSecondaryAction from "components/common/ListItemSecondaryAction";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const SidebarMenu = (props) => {
  const { menuConfig = [], isDrawerExpanded, onLogoutClick } = props;
  const [secondryExpanded, setSecondryExpanded] = useState(false);
  const [secondryExpandedAC, setSecondryExpandedAC] = useState(false);


  const classes = useStyles();
  return (
    <List
      classes={{
        root: classes.listRoot,
      }}
    >
      {menuConfig.map((item, index) => {
        const {
          type,
          onClick = () => {},
          primaryText,
          secondaryText = "",
          secondaryTextAC = "",

          icon = null,
          icon2 = null,
          secondaryAction = "",
          isActive = false,
          isDisabled = false,
          avatar,
          secondary = {},
          secondaryAC = {},

        } = item;
        const key = `${type}__${index}`;

        if (type === "header") {
          return <ListSubheader key={key}>{primaryText}</ListSubheader>;
        }

        if (type === "item") {
          if (isDrawerExpanded) {
            return (
              <ListItem key={key} sx={{ py: 0 }}>
                <ListItemButton
                  onClick={onClick}
                  disabled={isDisabled}
                  classes={{
                    root: cx({
                      [classes.listItemRoot]: true,
                      [classes.listItemActive]: isActive,
                    }),
                  }}
                >
                  {icon && (
                    <ListItemIcon classes={{ root: classes.listItemIconRoot }}>
                      {icon}
                    </ListItemIcon>
                  )}
                  {avatar && (
                    <ListItemAvatar
                      classes={{ root: classes.listItemAvatarRoot }}
                    >
                      {avatar}
                    </ListItemAvatar>
                  )}
                  <ListItemText
                    primary={primaryText}
                    secondary={secondaryText}
                    classes={{
                      primary: cx({
                        [classes.listItemPrimaryText]: true,
                        [classes.listItemPrimaryTextActive]: isActive,
                      }),
                      secondary: cx({
                        [classes.listItemSecondaryText]: true,
                        [classes.listItemSecondaryTextActive]: isActive,
                      }),
                    }}
                  />

                  {icon2 && (
                    <ListItemIcon classes={{ root: classes.listItemIconRoot }}>
                      {icon2}
                    </ListItemIcon>
                  )}
                  {secondaryAction ? (
                    <ListItemSecondaryAction>
                      {secondaryAction}
                    </ListItemSecondaryAction>
                  ) : null}
                </ListItemButton>
              </ListItem>
            );
          }
          return (
            <ListItem key={key} sx={{ px: 1.5, py: 0 }}>
              <ListItemButton
                onClick={onClick}
                disabled={isDisabled}
                classes={{
                  root: cx({
                    [classes.listItemCollapsedRoot]: true,
                    [classes.listItemActive]: isActive,
                  }),
                }}
              >
                {icon && (
                  <IconButton disableRipple disableFocusRipple>
                    {icon}
                  </IconButton>
                )}
                {avatar && (
                  <ListItemAvatar
                    classes={{ root: classes.listItemAvatarRoot }}
                  >
                    {avatar}
                  </ListItemAvatar>
                )}
              </ListItemButton>
            </ListItem>
          );
        }

        if (type === "secondry") {
          if (isDrawerExpanded) {
            return (
              <>
                <ListItem key={key} sx={{ py: 0 }}>
                  <ListItemButton
                    onClick={() => {
                      setSecondryExpanded(!secondryExpanded);
                    }}
                    disabled={isDisabled}
                    classes={{
                      root: cx({
                        [classes.listItemRoot]: true,
                        [classes.listItemActive]: isActive,
                      }),
                    }}
                  >
                    {icon && (
                      <ListItemIcon
                        classes={{ root: classes.listItemIconRoot }}
                      >
                        {icon}
                      </ListItemIcon>
                    )}
                    {avatar && (
                      <ListItemAvatar
                        classes={{ root: classes.listItemAvatarRoot }}
                      >
                        {avatar}
                      </ListItemAvatar>
                    )}
                    <ListItemText
                      primary={primaryText}
                      secondary={secondaryText}
                      classes={{
                        primary: cx({
                          [classes.listItemPrimaryText]: true,
                          [classes.listItemPrimaryTextActive]: isActive,
                        }),
                        secondary: cx({
                          [classes.listItemSecondaryText]: true,
                          [classes.listItemSecondaryTextActive]: isActive,
                        }),
                      }}
                    />
                    {secondryExpanded ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowRightIcon />
                    )}
                  </ListItemButton>
                </ListItem>
                {secondryExpanded
                  ? secondary.map((secondary) => (
                      <ListItem key={key} sx={{ py: 0 }}>
                        <ListItemButton
                          onClick={secondary.onClick}
                          classes={{
                            root: cx({
                              [classes.listItemRoot]: true,
                              [classes.listItemActive]: isActive,
                            }),
                          }}
                        >
                          {secondary.icon && (
                            <ListItemIcon
                              classes={{ root: classes.listItemIconRoot }}
                            >
                              {secondary.icon}
                            </ListItemIcon>
                          )}
                          {secondary.avatar && (
                            <ListItemAvatar
                              classes={{ root: classes.listItemAvatarRoot }}
                            >
                              {secondary.avatar}
                            </ListItemAvatar>
                          )}
                          <ListItemText
                            primary={secondary.primaryText}
                            secondary={secondaryText}
                            classes={{
                              primary: cx({
                                [classes.listItemPrimaryText]: true,
                                [classes.listItemPrimaryTextActive]:
                                  secondary.isActive,
                              }),
                              secondary: cx({
                                [classes.listItemSecondaryText]: true,
                                [classes.listItemSecondaryTextActive]:
                                  secondary.isActive,
                              }),
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))
                  : null}
              </>
            );
          }
          return (
            <ListItem key={key} sx={{ px: 1.5, py: 0 }}>
              <ListItemButton
                onClick={onClick}
                disabled={isDisabled}
                classes={{
                  root: cx({
                    [classes.listItemCollapsedRoot]: true,
                    [classes.listItemActive]: isActive,
                  }),
                }}
              >
                {icon && (
                  <IconButton disableRipple disableFocusRipple>
                    {icon}
                  </IconButton>
                )}
                {avatar && (
                  <ListItemAvatar
                    classes={{ root: classes.listItemAvatarRoot }}
                  >
                    {avatar}
                  </ListItemAvatar>
                )}
              </ListItemButton>
            </ListItem>
          );
        }

        if (type === "secondryAC") {
          if (isDrawerExpanded) {
            return (
              <>
                <ListItem key={key} sx={{ py: 0 }}>
                  <ListItemButton
                    onClick={() => {
                      setSecondryExpandedAC(!secondryExpandedAC);
                    }}
                    disabled={isDisabled}
                    classes={{
                      root: cx({
                        [classes.listItemRoot]: true,
                        [classes.listItemActive]: isActive,
                      }),
                    }}
                  >
                    {icon && (
                      <ListItemIcon
                        classes={{ root: classes.listItemIconRoot }}
                      >
                        {icon}
                      </ListItemIcon>
                    )}
                    {avatar && (
                      <ListItemAvatar
                        classes={{ root: classes.listItemAvatarRoot }}
                      >
                        {avatar}
                      </ListItemAvatar>
                    )}
                    <ListItemText
                      primary={primaryText}
                      secondary={secondaryTextAC}
                      classes={{
                        primary: cx({
                          [classes.listItemPrimaryText]: true,
                          [classes.listItemPrimaryTextActive]: isActive,
                        }),
                        secondaryAC: cx({
                          [classes.listItemSecondaryText]: true,
                          [classes.listItemSecondaryTextActive]: isActive,
                        }),
                      }}
                    />
                    {secondryExpandedAC ? (
                      <KeyboardArrowDownIcon />
                    ) : (
                      <KeyboardArrowRightIcon />
                    )}
                  </ListItemButton>
                </ListItem>
                {secondryExpandedAC
                  ? secondaryAC.map((secondary) => (
                      <ListItem key={key} sx={{ py: 0 }}>
                        <ListItemButton
                          onClick={secondary.onClick}
                          classes={{
                            root: cx({
                              [classes.listItemRoot]: true,
                              [classes.listItemActive]: isActive,
                            }),
                          }}
                        >
                          {secondary.icon && (
                            <ListItemIcon
                              classes={{ root: classes.listItemIconRoot }}
                            >
                              {secondary.icon}
                            </ListItemIcon>
                          )}
                          {secondary.avatar && (
                            <ListItemAvatar
                              classes={{ root: classes.listItemAvatarRoot }}
                            >
                              {secondary.avatar}
                            </ListItemAvatar>
                          )}
                          <ListItemText
                            primary={secondary.primaryText}
                            secondary={secondaryText}
                            classes={{
                              primary: cx({
                                [classes.listItemPrimaryText]: true,
                                [classes.listItemPrimaryTextActive]:
                                  secondary.isActive,
                              }),
                              secondary: cx({
                                [classes.listItemSecondaryText]: true,
                                [classes.listItemSecondaryTextActive]:
                                  secondary.isActive,
                              }),
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    ))
                  : null}
              </>
            );
          }
          return (
            <ListItem key={key} sx={{ px: 1.5, py: 0 }}>
              <ListItemButton
                onClick={onClick}
                disabled={isDisabled}
                classes={{
                  root: cx({
                    [classes.listItemCollapsedRoot]: true,
                    [classes.listItemActive]: isActive,
                  }),
                }}
              >
                {icon && (
                  <IconButton disableRipple disableFocusRipple>
                    {icon}
                  </IconButton>
                )}
                {avatar && (
                  <ListItemAvatar
                    classes={{ root: classes.listItemAvatarRoot }}
                  >
                    {avatar}
                  </ListItemAvatar>
                )}
              </ListItemButton>
            </ListItem>
          );
        }


        if (type === "divider") {
          return (
            <ListItem key={key} className={classes.divider}>
              <Divider />
            </ListItem>
          );
        }

        if (type === "spacer") {
          return <ListItem key={key} className={classes.spacer} />;
        }

        if (type === "logout") {
          if (isDrawerExpanded) {
            return (
              <ListItem
                key={key}
                sx={{
                  py: 0,
                  position: "sticky",
                  bottom: "0rem",
                  backgroundColor: "white",
                }}
              >
                <ListItemButton
                  onClick={onLogoutClick}
                  disabled={isDisabled}
                  classes={{
                    root: cx({
                      [classes.listItemRoot]: true,
                      [classes.listItemActive]: isActive,
                    }),
                  }}
                >
                  {icon && (
                    <ListItemIcon classes={{ root: classes.listItemIconRoot }}>
                      {icon}
                    </ListItemIcon>
                  )}
                  {avatar && (
                    <ListItemAvatar
                      classes={{ root: classes.listItemAvatarRoot }}
                    >
                      {avatar}
                    </ListItemAvatar>
                  )}
                  <ListItemText
                    primary={primaryText}
                    secondary={secondaryText}
                    classes={{
                      primary: cx({
                        [classes.listItemLogoutText]: true,
                        [classes.listItemPrimaryTextActive]: isActive,
                      }),
                      secondary: cx({
                        [classes.listItemSecondaryText]: true,
                        [classes.listItemSecondaryTextActive]: isActive,
                      }),
                    }}
                  />
                  {secondaryAction ? (
                    <ListItemSecondaryAction>
                      {secondaryAction}
                    </ListItemSecondaryAction>
                  ) : null}
                </ListItemButton>
              </ListItem>
            );
          }
          return (
            <ListItem
              key={key}
              sx={{ px: 1.5, py: 0, position: "absolute", bottom: "1.375rem" }}
            >
              <ListItemButton
                onClick={onLogoutClick}
                disabled={isDisabled}
                classes={{
                  root: cx({
                    [classes.listItemCollapsedRoot]: true,
                    [classes.listItemActive]: isActive,
                  }),
                }}
              >
                {icon && (
                  <IconButton disableRipple disableFocusRipple>
                    {icon}
                  </IconButton>
                )}
                {avatar && (
                  <ListItemAvatar
                    classes={{ root: classes.listItemAvatarRoot }}
                  >
                    {avatar}
                  </ListItemAvatar>
                )}
              </ListItemButton>
            </ListItem>
          );
        }

        return null;
      })}
    </List>
  );
};

const useStyles = makeStyles((theme) =>
  createStyles({
    evRoot: {
      display: "flex",
      flexDirection: "column",
    },

    listRoot: {
      paddingRight: "8px",
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    listItemRoot: {
      borderRadius: `${theme.spacing(0.5)} !important`,
      padding: `${theme.spacing(1.3)} !important`,
      paddingRight: `${theme.spacing(1.5)} !important`,
      display: "flex",
      width: "100%",
    },
    listItemCollapsedRoot: {
      borderRadius: `${theme.spacing(0.5)} !important`,
      paddingLeft: `${theme.spacing(1)} !important`,
      paddingRight: `${theme.spacing(1)} !important`,
      justifyContent: "center !important",
    },
    listItemActive: {
      backgroundColor: `${alpha(theme.palette.primary.main, 0.12)} !important`,
    },

    listItemAvatarRoot: {
      minWidth: "24px !important",
    },
    listItemIconRoot: {
      minWidth: "24px !important",
    },

    listItemPrimaryText: {
      fontSize: "1rem !important",
      color: "#3a3a3d !important",
      lineHeight: `${theme.typography.body2.lineHeight} !important`,
    },
    listItemLogoutText: {
      fontSize: `${theme.typography.body2.fontSize} !important`,
      color: "#545454 !important",
      fontWeight: "bold !important",
      lineHeight: `${theme.typography.body2.lineHeight} !important`,
    },

    listItemPrimaryTextActive: {
      color: `${theme.palette.primary.main} !important`,
      fontWeight: `bold !important`,
    },

    listItemSecondaryText: {
      fontSize: `${theme.typography.caption1.fontSize} !important`,
      color: "#252C32 !important",
      lineHeight: `${theme.typography.body2.lineHeight} !important`,
      maxWidth: "130px",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    listItemSecondaryTextActive: {
      color: `${theme.palette.primary.main} !important`,
    },

    spacer: {
      flexGrow: 1,
    },

    divider: {
      display: "block !important",
      paddingLeft: "0 !important",
      paddingRight: "0 !important",
    },
  })
);

export default React.memo(SidebarMenu);
